import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=24ab2ad8&scoped=true"
import script from "./programme.vue?vue&type=script&lang=js"
export * from "./programme.vue?vue&type=script&lang=js"
import style0 from "./programme.vue?vue&type=style&index=0&id=24ab2ad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab2ad8",
  null
  
)

export default component.exports